class Hero {

    static LL_THRESHOLD = 1000;

    name;
    seasonPoint;
    allTimePoint;

    constructor(name, seasonPoint, allTimePoint) {
        this.name         = name
        this.seasonPoint  = seasonPoint
        this.allTimePoint = allTimePoint
    }
}

export default Hero